import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TrackingService } from '@shared/services/tracking.service';

export enum WidgetSteps {
  REGISTRATION = 'registration',
  THANKS = 'thanks'
}

export enum WidgetCloseTarget {
  BACKGROUND = 'background',
  CLOSE_ICON = 'icon',
  CLOSE_THANKS = 'thanks',
  CLOSE_BTN = 'button'
}

@Component({
  selector: 'app-strategy-interview-widget',
  templateUrl: './strategy-interview-widget.component.html',
  styleUrls: ['./strategy-interview-widget.component.scss'],
  animations: [
    trigger('showWidget', [
      transition(':enter', [style({ opacity: 0 }), animate('250ms ease-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('250ms ease-out', style({ opacity: 0 }))])
    ])
  ],
  standalone: false
})
export class StrategyInterviewWidgetComponent implements OnInit {
  @Input() showWidget: boolean;
  @Output() closeWidget = new EventEmitter<void>();

  widgetStep: WidgetSteps;
  widgetSteps = WidgetSteps;
  widgetCloseTarget = WidgetCloseTarget;

  constructor(private trackingService: TrackingService) {}

  ngOnInit(): void {
    this.widgetStep = WidgetSteps.REGISTRATION;
  }

  onParticipate() {
    this.trackingService.trackActivity('[Button] Interview Widget: Participate interview');
    this.widgetStep = this.widgetSteps.THANKS;
  }

  onClose(closeTarget: WidgetCloseTarget) {
    this.trackingService.trackActivity(this.getCloseLeadActivity(closeTarget));
    this.closeWidget.emit();
  }

  getCloseLeadActivity(closeTarget: WidgetCloseTarget) {
    switch (closeTarget) {
      case WidgetCloseTarget.CLOSE_THANKS:
        return '[Button] Interview Widget: No, thanks';
      case WidgetCloseTarget.CLOSE_BTN:
        return '[Button] Interview Widget: Close';
      case WidgetCloseTarget.CLOSE_ICON:
        return '[Button] Interview Widget: Close icon';
      case WidgetCloseTarget.BACKGROUND:
        return '[Button] Interview Widget: Close background';
    }
  }
}
